export class KnownComponentsNames {
	public static readonly WebViewer: string = 'webViewer';
	public static readonly PastOrdersComponent: string = 'pastOrders';
	public static readonly PatientOrdersComponent: string = 'patientOrders';
	public static readonly AohsComponent: string = 'itero-aohs';
	public static readonly OrdersPage: string = 'orders-page';
	public static readonly IosimPlus: string = 'iosimplus';
	public static readonly ImageHub = 'image-hub';
	public static readonly AccountManagementAppId = 'account-management-ui';
	public static readonly AccountManagement = 'practice-management';
	public static readonly UnknownComponent: string = 'unknown';
	// TODO: Remove axi-wrapper once Client Discovery updates to itero-axi-wrapper.
	public static readonly AxiWrapper = 'axi-wrapper';
	public static readonly IteroAxiWrapper = 'itero-axi-wrapper';
	public static readonly MyiteroEnt = 'myitero-ent-ui';
	public static readonly MyiteroLab = 'mifl';
	public static readonly MyiteroDoctor = 'myitero';
	public static readonly Web3dTool = 'web3dtool';
	public static readonly PatientApp = 'patient-app';
	public static readonly RemoteApplicationLoader = 'remote-application-loader';
}
